"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var routes = /** @class */ (function () {
    function routes() {
    }
    routes.page_auth = "page-auth";
    routes.page_404 = "page-404";
    routes.page_main_dashboard = "page-main-dashboard";
    routes.page_main_brands = "page-main-brands";
    routes.page_main_redirects = "page-main-redirects";
    routes.page_main_clients_list = "page-main-clients-list";
    routes.page_main_landings_list = "page-main-landings-list";
    routes.page_main_frontends_list = "page-main-frontends-list";
    routes.page_main_brands_routes = "page-main-brands-routes";
    routes.page_main_brands_domains = "page-main-brands-domains";
    routes.page_main_emails = "page-main-emails";
    routes.page_main_messages = "page-main-messages";
    routes.page_gift_bonuses = "page-gift-bonuses";
    routes.page_gift_bonus_validators = "page-gift-bonus-validators";
    routes.page_gift_levels = "page-gift-levels";
    routes.page_gift_promocodes = "page-gift-promocodes";
    routes.page_gift_event_bindings = "page-gift-event-bindings";
    routes.page_gift_jackpots = "page-gift-jackpots";
    routes.page_gift_personal = "page-gift-personal";
    routes.page_gift_freespin_ranges = "page-gift-freespin-ranges";
    routes.page_gift_tournaments = "page-gift-tournaments";
    routes.page_admin_profile = "page-admin-profile";
    routes.page_gws_gameproviders = "page-gws-gameproviders";
    routes.page_gws_payments = "page-gws-payments";
    routes.page_usr_permissions = "page-usr-permissions";
    routes.page_usr_admins = "page-usr-admins";
    routes.page_finance_deposits_list = "page-finance-deposits-list";
    routes.page_finance_withdraws_list = "page-finance-withdraws-list";
    routes.page_finance_revshares_list = "page-finance-revshares-list";
    routes.page_finance_withdraw_requests_list = "page-finance-withdraw-requests-list";
    routes.page_finance_reconciliations_list = "page-finance-reconciliations-list";
    routes.page_config_main_config = "page-config-main-config";
    routes.page_config_currency_config = "page-config-currency-config";
    routes.page_config_css_config = "page-config-css-config";
    routes.page_config_country_config = "page-config-country-config";
    routes.page_config_language_config = "page-config-language-config";
    routes.page_config_usr_players_tags = "page-config-usr-players-tags";
    routes.page_config_payouts = "page-config-payouts";
    routes.page_config_trust_zones = "page-config-trust-zones";
    routes.page_paysystem_wallets = "page-paysystem-wallets";
    routes.page_paysystem_services = "page-paysystem-services";
    routes.page_paysystem_transactions = "page-paysystem-transactions";
    routes.page_cms_images_list = "page-cms-images-list";
    routes.page_cms_posts_list = "page-cms-posts-list";
    routes.page_cms_pages_list = "page-cms-pages-list";
    routes.page_cms_banners_list = "page-cms-banners-list";
    routes.page_cms_games_list = "page-cms-games-list";
    routes.page_cms_bots_list = "page-cms-bots-list";
    routes.page_cms_winners_top_list = "page-cms-winners-top-list";
    routes.page_cms_top_games_list = "page-cms-top-games-list";
    routes.page_par_affilates = "page-par-affilates";
    routes.page_par_brands_banners = "page-par-brands-banners";
    routes.page_par_brands_brandings = "page-par-brands-brandings";
    routes.page_par_brands_landings = "page-par-brands-landings";
    routes.page_par_brands_offers = "page-par-brands-offers";
    routes.page_par_partners = "page-par-partners";
    routes.page_par_images = "page-par-images";
    routes.page_par_news_list = "page-par-news-list";
    routes.page_report_brand_profit_list = "page-report-brand-profit-list";
    routes.page_report_bonuses_usage_list = "page-report-bonuses-usage-list";
    routes.page_report_promo_tpl_usage_list = "page-report-promo-tpl-usage-list";
    routes.page_support_promo_search_list = "page-support-promo-search-list";
    routes.page_support_player_search_list = "page-support-player-search-list";
    routes.page_support_personal_promo = "page-support-personal-promo";
    routes.page_report_player_profit_list = "page-report-player-profit-list";
    routes.page_report_paysystem_list = "page-report-paysystem-list";
    routes.page_report_withdrawals_list = "page-report-withdrawals-list";
    routes.page_security_firewall = "page-security-firewall";
    routes.page_security_trustzones = "page-security-trustzones";
    routes.page_security_capchas = "page-security-capchas";
    return routes;
}());
exports.routes = routes;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/shared/includes/routes.ts
// module id = 28
// module chunks = 0